export const columns = [
  {
    title: 'Sigiliu',
    field: 'sealCode'
  },
  {
    title: 'Plecare',
    field: 'source'
  },
  {
    title: 'Sosire',
    field: 'destination'
  },
  {
    title: 'Operator sigilare',
    field: 'sourceOperator'
  },
  {
    title: 'Data sigilare',
    field: 'created'
  },
  {
    title: 'Operator receptie',
    field: 'destinationOperator'
  },
  {
    title: 'Conform',
    field: 'conform'
  },
  {
    title: 'Data receptie',
    field: 'verificationDate'
  }
]
